import { useJackpotHistory } from '@hooks/queries/useJackpot'
import { JACKPOT_MESSAGES, JACKPOT_VIEW_TYPE } from '@constants/jackpotConstants'
import SpinningLoader from '../../../../../components/loaders/SpinningLoader'
import JackpotCardController from './JackpotCardController'

// Flat list, no pagination — matches defenderV2 (fetches the whole history in
// one shot, no page/size params, no pagination UI).
const JackpotHistoryTab = () => {
  const { data, isPending, isError } = useJackpotHistory()
  const rows = data?.rows ?? []

  if (isPending) {
    return (
      <div className="standard-normal-jackpot-tab-outer-container">
        <SpinningLoader />
      </div>
    )
  }

  if (isError || !rows.length) {
    return (
      <div className="standard-normal-jackpot-tab-outer-container">
        <div className="standard-normal-jackpot-tab-empty-message">
          {isError ? 'Ooops! Something Went Wrong!' : JACKPOT_MESSAGES.NO_HISTORY}
        </div>
      </div>
    )
  }

  return (
    <div className="standard-normal-jackpot-tab-outer-container">
      <div className="standard-normal-jackpot-tab-list-container no-scrollbar">
        {rows.map((row) => (
          <JackpotCardController key={row.id} jackpot={row} viewType={JACKPOT_VIEW_TYPE.HISTORY} />
        ))}
      </div>
    </div>
  )
}

export default JackpotHistoryTab
